import React from 'react';
import styled from 'styled-components';
import ReactLoading from 'react-loading';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
`;

const LabelText = styled.div`
  margin-top: 0.75rem;
  color: #363636;
  font-size: 0.9rem;
`;

const Loading = ({ color, label }) => (
  <Container>
    <ReactLoading type="spin" color={color || '#363636'} />
    {label && <LabelText>{label}</LabelText>}
  </Container>
);

export default Loading;
